import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Hint from '../components/Hint/Hint';
import PageHeading from '../components/PageHeading/PageHeading';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost, validateEmail } from '../helpers/Helpers';
import withForm from '../pages/withForm';
const LoginTemporaryLoginCreate = ({handleChange}) => {

    const {
        settingData
    } = useMenu();
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [role, setRole] = useState('');
    const [redirect, setRedirect] = useState('');
    const [expiryTime, setExpiryTime] = useState('');
    const [customExpiryTime, setCustomExpiryTime] = useState('');
    const [locale, setLocale] = useState('');

    const [reload, setReload] = useState(0);


    const [pageList,setPageList] = useState([])
    const [userRole,setUserRole] = useState([])
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [installedLanguages, setInstallLanguages] = useState([])

    useEffect(()=>{
        setPageList([
            { code: "wp-admin", value: __( "Dashboard", 'ultimate-security' ) },
            { code: "home", value: __( "Website Home Page", 'ultimate-security' ) },
            ...(ultimate_security_ajax_obj?.pageList || []),
        ]);
        if(settingData?.login?.settings?.visible_roles.length){
            setUserRole(settingData?.login?.settings?.visible_roles)
        } else {
            setUserRole(ultimate_security_ajax_obj?.userRoleList || [])
        }
        setRole(settingData?.login?.settings?.default_role)
        setRedirect(settingData?.login?.settings?.default_redirect_to)
        setExpiryTime(settingData?.login?.settings?.default_expiry_time)
    },[settingData]) 

    useEffect(()=> {
        const fetchLanguages = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-languages",
                    method: 'GET'
                });
        
                setInstallLanguages(results?.installed);
                setAvailableLanguages(results?.available);
        
            } catch (error) {
                console.error("Error fetching languages:", error);
            }
        };
        fetchLanguages();
    },[])


    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const handleAction = async () => {
        if(email.trim() == "" || firstName.trim() == "" || userName.trim() == ""){
            alert(__( 'Please fill all the required form', 'ultimate-security' ));
            return false;
        }
        
        if (!validateEmail(email)) {
            alert(__( 'Invalid email address', 'ultimate-security' ));
            return false;
        }

        setProcessing(true);
        setProcessingRing(true);

        try {
            const result = await formDataPost(
                "ultimate_security_create_temporary_user", 
                {
                    email: email,
                    first_name: firstName,
                    last_name: lastName,
                    user_name: userName,
                    role: role,
                    redirect: redirect,
                    expiry_time: expiryTime,
                    custom_expiry_date: customExpiryTime,
                    locale: locale,
                }
            );
            // console.log('result: ',result) 
            if (result.success_message) {
                setProcessingRing(false);
                setProcessingTick(true)
                setReload(Math.random)
                setTimeout(()=> {
                    setFirstName('');
                    setEmail('');
                    setFirstName('');
                    setLastName('');
                    setUserName('');
                    setRole('');
                    setRedirect('');
                    setExpiryTime('');
                    setCustomExpiryTime('');
                    setLocale('');
                    setProcessingTick(false);
                    setProcessing(false);
                },1000)
            }
                
            // setReload(prev => !prev); // Trigger reload to force re-render
        } catch (error) {
            // console.log(error.message);
        } finally {
            setProcessing(false);
            setProcessingRing(false)
        }       
    }

    // Datatable

    const [selectedRows, setSelectedRows] = useState([])
    const [bulkAction, setBulkAction] = useState("-1")
    const [userList,setUserList] = useState([])
    const [records, setRecords] = useState([])
    const [roleList,setRoleList] = useState([])
    const [activeRole, setActiveRole] = useState('')
    const [searchQuery,setSearchQuery] = useState('')
    const columns =  [
        { 
            id: 'username',
            name: 'Username',
            cell: row => (
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <img src={row.data.avatar} alt={row.data.display_name} width="40" height="40" />
                    <span><b>{row.data.user_login}</b></span>
                </div>
            ),

        },
        {
            id: 'role',
            name: 'Role',
            selector: row => row.data.role,
            sortable: true,
        },
        { 
            id: 'last-logged-in',
            name: 'Last Logged In',
            selector: row => row.data.ultimate_security_user_last_logged_in,
            sortable: true,
        },
        { 
            id: 'count',
            name: 'Count',
            selector: row => row.data.ultimate_security_user_logged_count,
            sortable: true,
        },
        { 
            id: 'expiry',
            name: 'Expiry',
            selector: row => row.data.ultimate_security_user_expiration,
            sortable: true,
        },
        { 
            id: 'actions',
            name: 'Actions',
            cell: row => (
                <div className="action-button-wrap d-flex justify-content-end gap-3">
                    <img title={__( "Copy", 'ultimate-security' )} src={ultimate_security_ajax_obj.imageUrl+'clipboard.svg'} role="button" onClick={()=> handleCopy(row.data.login_url)}/>
                    <img title={__( "Delete", 'ultimate-security' )} src={ultimate_security_ajax_obj.imageUrl+'user-delete.svg'} role="button" onClick={()=> deleteTempUserData(row.ID)}/>
                </div>
            ),
            ignoreRowClick: true, // Prevent triggering row click event
            allowoverflow: true, // Ensure it doesn’t interfere with other UI
            button: true, // Ensures proper styling for buttons
            right: true,
            style: {display: 'flex', justifyContent: 'end', paddingRight: '11px'}
        }
    ]

    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getRoleData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-temporary-roles`,
                    method: 'GET'
                });
        
                const rolesArray = Object.entries(response).map(([key, value]) => ({
                    role: key,
                    ...value
                }));
        
                setRoleList(rolesArray);
        
            } catch (error) {
                // console.log(error);
            }
        };
        getRoleData();
    },[reload])
    
    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getUserData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-temp-users`,
                    method: 'GET'
                });
        
                setUserList(response);
                setRecords(response);
        
            } catch (error) {
                // console.log(error);
            }
        };
        getUserData();
    },[reload])

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
        // console.log(selectedRows)
    };
    const handleUserSearch = (e) => {
        setSearchQuery(e.target.value)
        setActiveRole('') // Reset the active role
        const newData = userList.filter(row => {
            return row.data.user_login.toLowerCase().includes(e.target.value.toLowerCase())
        })
        setRecords(newData)
    }
    const handleUserFilter = (role) => {
        setSearchQuery('')
        if (role == 'All') {
            setRecords(userList)        
            setActiveRole(''); // Set the active role
        } else {
            const newData = userList.filter(row => {
                return row.data.role.toLowerCase().includes(role.toLowerCase())
            })
            setRecords(newData)        
            setActiveRole(role); // Set the active role
        }
    }

    const handleClickDeleteAll = async () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            try {

                // const ids = selectedRows.map(item => item.ID);
                // console.log("Deleting these ids:", ids);

                // Process all deletions in parallel
                const deletePromises = userList.map(user => 
                    formDataPost("ultimate_security_delete_temp_user", { user_id: user.ID })
                );

                // Wait for all deletions to complete
                const results = await Promise.all(deletePromises);

                // Check results
                const allSuccess = results.every(result => result.success_message);
                if (allSuccess) {
                    // alert(`Successfully deleted ${selectedRows.length} user(s).`);
                    setReload(Math.random()); // Refresh the list
                } else {
                    alert("Some deletions failed. Please check the console for details.");
                    // console.log("Delete results:", results);
                }

            } catch (error) {
                console.error("Delete all error:", error.message);
                alert("An error occurred during deletion. Please try again.");
            }
        }
    }
    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    
    const handleBulkActionSubmit = async () => {
        if (!selectedRows.length) {
            alert("Please select users.");
            return;
        }

        if (bulkAction !== "delete") {
            alert("Please select a valid action.");
            return;
        }

        try {
            // Confirm before deletion
            const isConfirmed = window.confirm(`Are you sure you want to delete ${selectedRows.length} selected user(s)?`);
            if (!isConfirmed) return;

            const ids = selectedRows.map(item => item.ID);
            // console.log("Deleting these ids:", ids);

            // Process all deletions in parallel
            const deletePromises = ids.map(id => 
                formDataPost("ultimate_security_delete_temp_user", { user_id: id })
            );

            // Wait for all deletions to complete
            const results = await Promise.all(deletePromises);

            // Check results
            const allSuccess = results.every(result => result.success_message);
            if (allSuccess) {
                // alert(`Successfully deleted ${selectedRows.length} user(s).`);
                setReload(Math.random()); // Refresh the list
            } else {
                alert("Some deletions failed. Please check the console for details.");
                // console.log("Delete results:", results);
            }

        } catch (error) {
            // console.error("Bulk delete error:", error.message);
            alert("An error occurred during deletion. Please try again.");
        }
    };


    const handleCopy = (text) => {
        try {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy"); // Fallback API
            document.body.removeChild(textArea);
            alert(__( "Text Copied Successfully", 'ultimate-security' ));
        } catch (error) {
            console.error(__( "Failed to copy text: ", 'ultimate-security' ), error);
        }
    } 
    const deleteTempUserData = async(id) => {
        const userConfirmed = window.confirm(__( 'Are you sure you want to proceed?', 'ultimate-security' ));
        if(userConfirmed){

            try {
                const result = await formDataPost(
                    "ultimate_security_delete_temp_user", 
                    {
                        user_id: id
                    }
                );
                // console.log('result: ',result) 
                if (result.success_message) {
                    setReload(Math.random)
                }
                    
            } catch (error) {
                // console.log(error.message);
            } finally {} 
        }
        
    }
    return (
        <> 
            <div className="setting-unit px-lg" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                <PageHeading 
                    title={__("Create a new Temporary Login", "ultimate-security")}
                    subtitle={__("Grant secure, time-limited access by creating a new temporary login. Perfect for collaborators or support without compromising your site's security.", "ultimate-security")}
                />
            </div>
            <div className="setting-unit pt-lg mt-lg pb-lg border-top">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Email", "ultimate-security")} <span className="text-extra">*</span></h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required={true}
                                    />
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("First Name", "ultimate-security")} <span className="text-extra">*</span>        </h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        required={true}
                                    />
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Last Name", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("User Name", "ultimate-security")} <span className="text-extra">*</span> </h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                        required={true}
                                    />
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Role", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={role} 
                                        onChange={(e) => setRole(e.target.value)}
                                    >
                                        {
                                            userRole.length && userRole.map(item=> (   
                                                <option 
                                                    value={item.code}
                                                    key={item.code} 
                                                >
                                                    {item.value}
                                                </option>                                     
                                            ))  
                                        }
                                    </select>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Redirect After Login", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={redirect} 
                                        onChange={(e) => setRedirect(e.target.value)}
                                    >
                                        {
                                            pageList.length && pageList.map(item=> (   
                                                <option 
                                                    value={item.code}
                                                    key={item.code} 
                                                >
                                                    {item.value}
                                                </option>                                     
                                            ))  
                                        }
                                    </select>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Expiry", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={expiryTime} 
                                        onChange={(e) => setExpiryTime(e.target.value)}
                                    >
                                        <option value="+1 hour">{__("One Hour", "ultimate-security")}</option>
                                        <option value="+3 hour">{__("Three Hours", "ultimate-security")}</option>
                                        <option value="+1 day">{__("One Day", "ultimate-security")}</option>
                                        <option value="+3 day">{__("Three Days", "ultimate-security")}</option>
                                        <option value="+1 week">{__("One Week", "ultimate-security")}</option>
                                        <option value="+1 month">{__("One Month", "ultimate-security")}</option>
                                        <option>{__( 'Custom Date', 'ultimate-security' )}</option>
                                    </select>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${expiryTime !== 'Custom Date'?'deactive-section':''}`}>
                <div className="setting-unit pt-lg pb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Custom Date", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Set Email", "ultimate-security")}/>
                                        <input 
                                            className="form-control"
                                            type="datetime-local"
                                            value={customExpiryTime}
                                            onChange={(e) => setCustomExpiryTime(e.target.value)}
                                        />
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Language", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={locale} 
                                        onChange={(e) => setLocale(e.target.value)}
                                        //installedLanguages Object.entries(installedLanguages).map(([key, value])
                                    >
                                        {Object.entries(installedLanguages).map(([key, value]) => (
                                            <option 
                                                key={key} 
                                                value={key}
                                            >
                                                {value}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                                <div className="content-below-with-hint mt-2"> 
                                    <div className="d-flex align-items-center gap-2">                                    
                                        <button 
                                            type="button" 
                                            className="button button-link" 
                                            onClick={handleAction}
                                            disabled={processing}
                                        >
                                            {
                                                processing ? __( "Processing...", "ultimate-security" ) : __( "Submit", "ultimate-security" )
                                            }
                                        </button>
                                        {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                        {processingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="user-datatable datatable-unit">
                    <div className="row justify-content-between mb-30">
                        <div className="col-8 filters">
                            <div className="d-flex flex-wrap wp-roles">
                                <span
                                    onClick={() => handleUserFilter('All')}
                                    className={activeRole === '' ? 'active' : ''} // Apply active class conditionally
                                    >{__( 'All', 'ultimate-security' )}</span>
                                {
                                    roleList && roleList.map(item=> (                                        
                                        item?.count ? 
                                        <span 
                                            key={item.role} 
                                            value={item.role} 
                                            onClick={() => handleUserFilter(item.name)}
                                            className={activeRole === item.name ? 'active' : ''} // Apply active class conditionally
                                        >
                                        {item.name} ({item.count})
                                        </span> 
                                        : ''                                        
                                    ))      
                                }
                            </div>
                            <div className="bulk-action-wrapper">
                                <select value={bulkAction} name="action"  onChange={handleBulkActionChange}>
                                    <option value="-1">{__( 'Bulk actions', 'ultimate-security' )}</option>
                                    <option value="delete">{__( 'Delete', 'ultimate-security' )}</option>
                                </select>
                                <button className="button button-secondary" onClick={handleBulkActionSubmit}>{__( 'Apply', 'ultimate-security' )}</button>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="search-unit d-flex gap-2 align-items-center">
                                <input placeholder="Search Users" type="search" onChange={handleUserSearch} value={searchQuery} />
                                <button className="button button-secondary" type="button">{__( 'Search', 'ultimate-security' )}</button>
                            </div>
                            <div className="action-buttons d-flex align-items-center">
                                <span onClick={handleClickDeleteAll}>{__( 'Delete All', 'ultimate-security' )}</span>
                            </div>
                        </div>
                    </div>            
                    <div className="table-wrapper">
                        <DataTable
                            columns={columns}
                            data={records}
                            selectableRows // for making row selectable
                            onSelectedRowsChange={handleSelectedRowsChange} // Handle row selection changes  
                          
                            pagination
                            dense
                            responsive
                        />
                    </div> 
                </div>  
            </div>
        </>
    )
}
export default withForm(LoginTemporaryLoginCreate);